import { GoalManager } from "@/components/management/GoalManager";
import { MobileLayout } from "@/components/layout/MobileLayout";
import { useIsMobile } from "@/hooks/use-mobile";

export default function GoalsPage() {
  const isMobile = useIsMobile();

  const handleTabChange = (tab: string) => {
    // Handle tab navigation if needed
  };

  const handleTransactionSuccess = () => {
    // Handle transaction success if needed
  };

  const goalsContent = (
    <div className={!isMobile ? "min-h-screen bg-background" : ""}>
      <div className={!isMobile ? "p-3 sm:p-4 md:p-6" : ""}>
        <div className={!isMobile ? "max-w-7xl mx-auto" : "max-w-7xl mx-auto px-4"}>
          <GoalManager onGoalUpdate={() => {}} />
        </div>
      </div>
    </div>
  );

  if (isMobile) {
    return (
      <MobileLayout
        currentTab="goals"
        onTabChange={handleTabChange}
        onTransactionSuccess={handleTransactionSuccess}
      >
        {goalsContent}
      </MobileLayout>
    );
  }

  return goalsContent;
}